import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Chip, IconButton, Link, Stack, Typography } from "@mui/material";
import { Order } from "models/Order";
import LinkOrdersDialog from "../dialogs/LinkOrdersDialog";
import { EditOutlined } from "@mui/icons-material";
import { useAuthContext } from "features/auth/AuthContext";
import { UserRole } from "features/auth/types/user";
import EmptyMessage from "components/EmptyMessage";

type ProjectGroupSectionProps = { order: Order };

const ProjectGroupSection: React.FC<ProjectGroupSectionProps> = (props) => {
  const { order } = props;
  const { hasRole } = useAuthContext();

  const [showEditReferenceDialog, setShowEditReferenceDialog] = useState(false);

  const canLinkOrders = hasRole([UserRole.ADMIN]);

  if (!order.projectGroup) return <EmptyMessage>Ingen projektgrupp</EmptyMessage>;

  return (
    <>
      <Typography fontWeight="bold" gutterBottom>
        {order.projectGroup} : {order.projectGroupName}
      </Typography>

      {order.parentOrderNumber && (
        <>
          <Typography fontSize="small">Huvudorder</Typography>
          <Link component={RouterLink} to={`/orders/view/${order.parentOrderNumber}`}>
            {order.parentOrderNumber}
          </Link>
        </>
      )}

      {!order.parentOrderNumber && (
        <>
          <Typography fontSize="small">Länkade ordrar</Typography>

          <Stack spacing={1} direction="row">
            {!order.pairedOrderNumbers?.length && <EmptyMessage>Ej länkad</EmptyMessage>}

            {order.pairedOrderNumbers.map((linkedOrderNumber) => (
              <Chip
                key={linkedOrderNumber}
                sx={{ fontSize: "1rem" }}
                label={
                  <Link component={RouterLink} to={`/orders/view/${linkedOrderNumber}`}>
                    {linkedOrderNumber}
                  </Link>
                }
              />
            ))}

            <IconButton
              size="small"
              onClick={() => setShowEditReferenceDialog(true)}
              hidden={!canLinkOrders}
            >
              <EditOutlined />
            </IconButton>
          </Stack>
        </>
      )}

      {showEditReferenceDialog && (
        <LinkOrdersDialog order={order} onClose={() => setShowEditReferenceDialog(false)} />
      )}
    </>
  );
};

export default ProjectGroupSection;
